import React from 'react';
import MyNavbar from "./Navbar";
import Footer from './Footer';
import logo from "../images/ttms_logo_1.png";
import './css/Base.css';
import './css/polish.css';
import './css/redesign.css';

const Base = ({
    title = "My Title",
    description = "My description",
    className = "bg-dark text-white pt-0",
    imageURL = logo,
    isHomePage = false,
    children
}) => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <MyNavbar />

            <div className="container-fluid flex-grow-1">
                <div className="jumbotron bg-dark text-white text-center base-jumbotron">
                    {isHomePage && (
                        <div className="row justify-content-center">
                            <div className="col-6 col-md-4">
                                <img
                                    className="img-fluid mb-4 base-logo"
                                    src={imageURL}
                                    alt="Triple Trans Mill Services Ltd."
                                    title="Triple Trans Mill Services Ltd."
                                />
                            </div>
                        </div>
                    )}

                    {!isHomePage && (
                        <h2 className="display-4 text-white base-title">
                            {title}
                        </h2>
                    )}

                    <h4 className="text-info base-description">
                        {description}
                    </h4>
                </div>

                <div className={className}>{children}</div>
            </div>

            <div className="mt-4">
                <Footer />
            </div>
        </div>
    );
};

export default Base;